import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect } from "react";

const Testing = () => {
  // useEffect(() => {
  //   const videoScroll = () => {
  //     console.log("here");
  //   };
  //   window.addEventListener("scroll", videoScroll);
  //   return () => {
  //     window.removeEventListener("scroll", videoScroll);
  //   };
  // }, []);
  // //   const videoScroll = () => {
  // //     console.log("here");
  // //   };
  // //   videoScroll();
  // //   console.log("here2");
  // return (
  //   <DashboardLayout>
  //     <DashboardNavbar />
  //     <MDBox height="2000px" border="1px solid red">
  //       <MDTypography color="singh">Hello</MDTypography>
  //     </MDBox>
  //   </DashboardLayout>
  // );
};

export default Testing;
